<template>
  <section
    ref='container'
    class="page-container">
    <div class="flex-sb-center">
      <h1>Private Car Class List</h1>
      <div class="flex">
        <v-button
          gray
          @click="handleClassInit">Car Class Init</v-button>
        <v-button
          gray
          class="mg-r-15"
          @click="handleClear">Cache Clear</v-button>
        <v-button
          v-if="!isModel"
          gray
          @click="handleCancel">Back</v-button>
        <v-button
          v-if="isModel"
          gray
          @click="handleBack">Back</v-button>
      </div>
    </div>
    <filter-top-select
      v-model="select_type"
      :list="carClasslist"
      @change="handlePath"></filter-top-select>
    <router-view
      ref="carForm"
      :class-id="classId"></router-view>
    <to-top :el='container'></to-top>
  </section>
</template>

<script>
import FilterTopSelect from '@/views/components/filter-top-select'
import MixinOptions from '@/mixins/options'
import {getCarClassInit,clearCarClass} from '@api/privateCarList'
export default {
  name: 'carList',
  components:{
    FilterTopSelect
  },
  mixins: [MixinOptions],
  data(){
    return{
      select_type:0,
      container:null,
      classId:11
    }
  },
  computed:{
    isModel(){
      let path = this.$route.path
      console.log('path-',path)
      return path.indexOf('manage-model')!=-1?true:false
    }
  },
  watch:{
    '$route.path':{
      immediate:true,
      handler(val){
        this.carClasslist.filter(item=>{
          if(val.indexOf(item.path)!=-1){
            this.select_type = item.id
          }
        })
      }
    }
  },
  mounted() {
    // await this.network().getCarClassInit()
    this.getElement()
  },
  methods:{
    handleClassInit() {
      this.network().getCarClassInit()
    },
    handleClear(){
      this.network().clearCarClass()
    },
    getElement(){
      this.container = this.$refs['container'].parentElement
    },
    handleCancel(){
      this.$router.push('/admin-cms/car-class-list')
    },
    handleBack(){
      this.$router.back()
    },
    handleSave(){
      this.$refs.carForm.handleUpdate()
    },
    handlePath(item){
      let {path} = item
      this.$router.push('/private-car-list/'+path)
    },
    network() {
      return {
        getCarClassInit: async () => {
          const { data } = await getCarClassInit({
            // page: this.pageConfig.currentPage,
            class_id:this.classId
          })
        },
        clearCarClass: async () => {
          const { data } = await clearCarClass({
            class_id:this.classId
          })
          let {code,message} = data||{}
          if(code == 1000) {
            this.$message({
              type: 'success',
              message: message
            })
          }
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  padding: 30px 70px;
  h1 {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    letter-spacing: 0.3px;
    color: #24292E;
    margin-bottom: 15px;
  }
}
</style>
